import { useEffect } from "react";
import PropTypes from "prop-types";
import { isEqual } from "lodash";
import { useWatch } from "react-hook-form";
import { DefaultsForm } from "./DefaultsForm";
import { SEOForm } from "./SEOForm";

export const Options = ({ metaData, setIsPristine, initialFormValues }) => {
  const formState = useWatch();

  useEffect(() => {
    if (!isEqual(formState, initialFormValues)) {
      setIsPristine(false);
    }
  }, [formState]);

  return (
    <div
      className="flex h-full w-full flex-col items-center gap-4 md:py-8"
      data-testid="customize-feed-options"
    >
      <DefaultsForm metaData={metaData} />
      <SEOForm />
    </div>
  );
};

Options.propTypes = {
  metaData: PropTypes.object,
  setIsPristine: PropTypes.func,
  initialFormValues: PropTypes.object,
};
